import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import { MapCard } from 'Components/_common/CollectionCard/MapCard'
import { PrefabCard } from 'Components/_common/CollectionCard/PrefabCard'
import NoContent from 'Components/_common/NoContent'
import { FilterContext } from 'Components/Filter/context'
import { useSearchContentQuery } from 'Queries/Common'
import React, { useContext, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { CONTENT_TYPES } from 'Scenes/constants'

import { SkeletonContainer } from './SkeletonContainer'

const InfiniteContentCardsList = ({ type = CONTENT_TYPES.MAPS, setMapsTotal, setPrefabsTotal }) => {
  const { normalizedFilters, clearFilters } = useContext(FilterContext)
  const [page, setPage] = useState(1)

  const { data, isFetching, fetchNextPage, isFetchingNextPage, hasNextPage } = useSearchContentQuery(
    { limit: 32, ...normalizedFilters },
    type,
  )

  useEffect(() => {
    const { total: dataTotal = 0 } = data?.pages[0] || {}
    type === CONTENT_TYPES.MAPS ? setMapsTotal(dataTotal) : setPrefabsTotal(dataTotal)
  }, [data?.pages, setMapsTotal, setPrefabsTotal, type])

  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage({ pageParam: page + 1 })
      setPage((prevPage) => prevPage + 1)
    }
  }, [inView, fetchNextPage, page, hasNextPage])

  return !isFetching && !data?.pages[0]?.data?.length ? (
    <NoContent
      onClear={clearFilters}
      text="Nothing found, change the query and try again"
    />
  ) : (
    <>
      <SkeletonContainer
        animation="pulse"
        variant="rectangular"
        blockHeight={262}
        showChildren={!!data?.pages.length}
        xs={12}
        sm={6}
        md={3}
      >
        {data?.pages?.map((page) =>
          page.data.map((content, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={String(content.id) + String(index)}
            >
              {type === CONTENT_TYPES.MAPS ? (
                <MapCard
                  map={content}
                  style={{ height: '262px' }}
                />
              ) : (
                <PrefabCard
                  prefab={content}
                  style={{ height: '262px' }}
                />
              )}
            </Grid>
          )),
        )}
      </SkeletonContainer>
      {!isFetchingNextPage && !isFetching && <div ref={ref} />}
      {isFetchingNextPage && (
        <Box
          display="flex"
          justifyContent="center"
          mt={5}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}
    </>
  )
}

export default React.memo(InfiniteContentCardsList)
